/**
 * PullQuote — three treatments: primary (full-bleed), inline (border-left), supporting (overline + serif).
 */
export function PullQuotePrimary({ children, attribution, dark = false, testid }) {
    return (
        <section
            data-testid={testid}
            className={`relative py-24 md:py-40 ${
                dark ? "bg-charcoal text-ivory" : "bg-ivory text-charcoal"
            }`}
        >
            <div className="container-narrow text-center">
                <span
                    aria-hidden="true"
                    className={`font-serif text-7xl md:text-9xl leading-none block mb-2 ${
                        dark ? "text-gold/40" : "text-oxblood/30"
                    }`}
                >
                    “
                </span>
                <blockquote className="pull-quote-primary italic">{children}</blockquote>
                {attribution && (
                    <p className="eyebrow mt-10 text-stone">{attribution}</p>
                )}
                <div className={`mx-auto mt-10 h-px w-16 ${dark ? "bg-gold/60" : "bg-oxblood/50"}`} />
            </div>
        </section>
    );
}

export function PullQuoteInline({ children, dark = false }) {
    return (
        <blockquote
            className={`relative pl-6 md:pl-8 py-2 border-l-2 ${
                dark ? "border-gold text-ivory/90" : "border-gold text-charcoal/90"
            }`}
        >
            <p className="pull-quote-secondary italic">{children}</p>
        </blockquote>
    );
}

export function PullQuoteSupporting({ label, children, dark = false }) {
    return (
        <div className="space-y-3">
            {label && (
                <p className={`eyebrow ${dark ? "text-gold/80" : "text-oxblood"}`}>{label}</p>
            )}
            <p
                className={`font-serif italic text-xl md:text-2xl leading-snug ${
                    dark ? "text-ivory/90" : "text-charcoal"
                }`}
            >
                {children}
            </p>
        </div>
    );
}
